// vendors
import { useState } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import isUrl from "is-url";
import ReactPlayer from 'react-player'

// components
import DeleteButton from "./delete-button";
import Icon from "../../../Icon";
import UIDialog from "./../../../Dialog";
import NodeType from "../../../NodeType";
import UIButton from "../../../Button";
import Input from "../../../Input";

// styles
import { MediaPlaceholderStyled } from "./common.styles";

const Video = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [url, setURL] = useState(props?.url);
  const [showUploadArea, setShowUploadArea] = useState(
    props?.url ? false : true
  );
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);

  const toggleDialog = () => {
    setShowModal(!showModal);
  };

  const onChange = (event: any) => {
    setURL(event.target.value);
  };

  const onSave = () => {
    setShowUploadArea(false);
    toggleDialog();
    props.onSave && props.onSave(url);
  };

  const handleDeleteClick = () => {
    setShowDeleteConfirmModal(true);
  };

  const handleConfirmDelete = () => {
    setURL("");
    setShowUploadArea(true);
    setShowDeleteConfirmModal(false);
    props.onDelete && props.onDelete();
  };

  return showUploadArea ? (
    <>
      <MediaPlaceholderStyled>
        <Icon icon="video" size={24} color="#5B73E8" />
        <UIButton
          sx={{ mt: "10px" }}
          variant="outlined"
          startIcon={<Icon icon="video" size={16} />}
          onClick={toggleDialog}
        >
          Video URL
        </UIButton>
      </MediaPlaceholderStyled>
      <UIDialog
        className="ignore-onClickOutside"
        onClick={(e) => {
          e.stopPropagation();
        }}
        open={showModal}
        onClose={toggleDialog}
        sx={{ minWidth: "420px" }}
      >
        <UIDialog.Header component="div" sx={{ padding: 0 }}>
          <Stack direction="row" justifyContent="space-between">
            <NodeType text="Video URL" icon="video" color="#FF8484" />
            <Box
              sx={{
                px: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconButton onClick={toggleDialog}>
                <Icon icon="close" size={16} />
              </IconButton>
            </Box>
          </Stack>
        </UIDialog.Header>
        <UIDialog.Body onClick={(e) => {
          e.stopPropagation();
        }} sx={{ px: "16px", pb: "8px", width: "100%" }}>
          <Typography
            component="label"
            sx={{
              color: "#7E8392",
              fontSize: "12px",
              lineHeight: "18px",
              fontWeight: 400,
            }}
          >
            URL (Supports Youtube, Vimeo, Vidyard, loom or Wistia.)
            <Input
              placeholder="link"
              id="video-link-input"
              size="small"
              name="url"
              onChange={onChange}
              onBlur={onChange}
              value={url}
              fullWidth
              error={url && url !== "" && !isUrl(url)}

            />
          </Typography>
        </UIDialog.Body>
        <UIDialog.Footer
          sx={{ justifyContent: "space-between", px: "16px", pb: "8px" }}
        >
          <UIButton variant="outlined" color="secondary" onClick={toggleDialog}>
            cancel
          </UIButton>
          <UIButton
            color="primary"
            variant="contained"
            startIcon={<Icon icon="save" size={16} />}
            onClick={onSave}
            disabled={!url || !isUrl(url)}
          >
            Save
          </UIButton>
        </UIDialog.Footer>
      </UIDialog>
    </>
  ) : (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ position: "absolute", top: "16px", right: "16px" }}>
        <DeleteButton onClick={handleDeleteClick} />
      </Box>
      <ReactPlayer url={url} width={"100%"} height="230px" controls={true}/>
      <UIDialog
        className="ignore-onClickOutside"
        open={showDeleteConfirmModal}
        onClose={() => setShowDeleteConfirmModal(false)}
        sx={{ minWidth: "420px" }}
      >
        <UIDialog.Header component="div" sx={{ padding: 0 }}>
          <Stack direction="row" justifyContent="space-between">
            <NodeType text="Remove URL" icon="video" color="#84CBFF" />
            <Box
              sx={{
                px: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconButton onClick={() => setShowDeleteConfirmModal(false)}>
                <Icon icon="close" size={16} />
              </IconButton>
            </Box>
          </Stack>
        </UIDialog.Header>
        <UIDialog.Body sx={{ px: "16px", pb: "8px", minWidth: "420px" }}>
          <Typography
            component="label"
            sx={{
              color: "#7E8392",
              fontSize: "12px",
              lineHeight: "18px",
              fontWeight: 400,
            }}
          >
            Are you sure you want to remove this video?
          </Typography>
        </UIDialog.Body>
        <UIDialog.Footer
          sx={{ justifyContent: "space-between", px: "16px", pb: "8px" }}
        >
          <UIButton
            color="secondary"
            variant="outlined"
            onClick={() => setShowDeleteConfirmModal(false)}
          >
            No
          </UIButton>
          <UIButton
            variant="contained"
            color="error"
            startIcon={<Icon icon="delete" size={16} />}
            onClick={handleConfirmDelete}
          >
            Yes
          </UIButton>
        </UIDialog.Footer>
      </UIDialog>
    </Box>
  );
};
export default Video;
